<template>
    <div class="home">
      <ActivityPageListComponents msg="页面列表"/>
    </div>
  </template>
  <script lang="ts">
  import { defineComponent } from 'vue'
  import ActivityPageListComponents from '@/components/ActivityPageListComponents.vue' // @ is an alias to /src
  
  export default defineComponent({
    name: 'activityPageList',
    components: {
      ActivityPageListComponents
    }
  })
  </script>